export default {

	selectors: {
		parent: '.link-block',
		item: '.link-block__item',
	},

	classes: {
		active: 'active',
		collapse: 'collapse',
	},

	init() {
		this.links = Array.from(document.querySelectorAll(this.selectors.item));
		this.links.forEach((link) => {
			link.addEventListener('mouseenter', this.linkMouseenter.bind(this));
			link.addEventListener('mouseleave', this.linkMouseleave.bind(this));
		});
	},

	linkMouseenter(e) {
		this.links.forEach((link) => {
			link.classList.remove(this.classes.active);
			link.classList.add(this.classes.collapse);
		});
		e.currentTarget.classList.add(this.classes.active);
		e.currentTarget.classList.remove(this.classes.collapse);
	},

	linkMouseleave(e) {
		e.currentTarget.classList.remove(this.classes.active);
		this.links.forEach((link) => {
			link.classList.remove(this.classes.collapse);
		});
	},

};
